import { useState, useEffect } from "react";

interface StraightLineProps {
  isActive?: boolean;
  className?: string;
  isEven?:boolean;
}

const StraightLine = ({ isActive = false, className = "", isEven }: StraightLineProps) => {
  const [pathLength, setPathLength] = useState(0);
  const activeColor = "#8FE45A";
  const inactiveColor = "rgb(var(--pd-rule))";

  useEffect(() => {
    if (isActive) {
      // Start animation with a small delay
      const timer = setTimeout(() => {
        setPathLength(1);
      }, 400);
      return () => clearTimeout(timer);
    } else {
      setPathLength(0);
    }
  }, [isActive]);

  return (
    <svg
      width={436}
      height={2}
      viewBox="0 0 436 2"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      {/* Background dashed path (always visible) */}
      <path
        d="M0 1L436 1"
        stroke={inactiveColor}
        strokeWidth={2}
        strokeDasharray="10 10"
      />
      
      {/* Animated solid path with direction based on isEven */}
      <path
        d="M0 1L436 1"
        stroke={activeColor}
        strokeWidth={3}
        strokeDasharray="436"
        strokeDashoffset={436 - pathLength * 436}
        style={{
          transition: "stroke-dashoffset 2s ease-in-out",
          transform: !isEven ? "scaleX(-1)" : "none",
          transformOrigin: "center"
        }}
    />
  </svg>
  );
};

export default StraightLine;
